import { render, staticRenderFns } from "./CoreImage.vue?vue&type=template&id=32554aae&"
import script from "./CoreImage.vue?vue&type=script&lang=js&"
export * from "./CoreImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports